// src/components/Login.js
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Modal,
  message,
  Divider,
  Card
} from "antd";
import { connect, useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next"; // 1) useTranslation import
import { login, verifyTfa } from "../../actions/auth/login";
import "react-phone-input-2/lib/style.css";

function Login(props) {
  const { t } = useTranslation(); // 2) hook'u kullan
  const [checkForm, setCheckForm] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nationalIdentifier, setNationalIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [isTfaModalOpen, setIsTfaModalOpen] = useState(false);
  const [tfaCode, setTfaCode] = useState("");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get("status");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (!checkForm) {
      message.error(t("login.tncError")); // 3) Metinleri i18n den al
      return;
    }
    dispatch(login(nationalIdentifier, password, setIsTfaModalOpen));
  };

  useEffect(() => {
    if (props.login?.done === true) {
      if (props.login?.isTfaNeeded) {
        setIsTfaModalOpen(true);
      } else if (props.login?.login?.user?.isNurse) {
        localStorage.setItem("IsNurse", true);
        navigate("/nurse-dashboard");
      } else if (props.login?.login?.user?.isDoctor) {
        localStorage.setItem("IsDoctor", true);
        navigate("/dashboard");
      } else {
        navigate("/select-facility");
      }
    } else if (
      props.login?.done === false &&
      props.login?.error?.status === 400
    ) {
      // Eğer backend'den gelen mesajı aynen göstermek isterseniz, i18n'e eklemeyebilirsiniz.
      // Dilerseniz sabit bir hata mesajı gösterebilir veya i18n'e taşıyabilirsiniz.
      const errorMessage = props.login?.error?.message || t("login.errorMsg");
      message.error(errorMessage);
    }
  }, [props.login]);

  const handleTfaSubmit = () => {
    if (!tfaCode) {
      message.error(t("login.twoFactorPlaceholder"));
      return;
    }
    dispatch(verifyTfa(nationalIdentifier, tfaCode)).then((response) => {
      if (response?.success) {
        message.success(t("login.successMsg"));
        setIsTfaModalOpen(false);

        const user = response.payload.user;
        console.log(user);

        if (user?.isDoctor) {
          localStorage.setItem("IsDoctor", true);
          navigate("/dashboard");
        } else if (user?.isNurse) {
          localStorage.setItem("IsNurse", true);
          navigate("/nurse-dashboard");
        } else {
          navigate("/select-facility");
        }
      } else {
        message.error(t("login.errorMsg"));
      }
    });
  };

  return (
    <div className="flex justify-center items-center max-h-screen md:h-screen bg-gray-100">
      <Card className="shadow-xl p-4 w-full max-w-full md:max-w-[600px] h-screen md:h-[500px] ">
        <div className="text-center mb-4">
          <h2 className="block text-lg font-bold text-gray-800 mb-5">
            {t("login.title")}
          </h2>
          <p className="text-sm text-gray-600">
            <Trans
              i18nKey="login.noAccount"
              components={{
                1: <Link to="/register-phone" className="text-blue-500" />
              }}
            />
          </p>
        </div>
        <Divider />
        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label={t("login.nationalId")}
            rules={[
              {
                required: true,
                message: t("login.nationalId") + " zorunludur!"
              }
            ]}
          >
            <Input
              value={nationalIdentifier}
              onChange={(e) => setNationalIdentifier(e.target.value)}
              placeholder={t("login.nationalId")}
            />
          </Form.Item>
          <Form.Item
            label={t("login.password")}
            rules={[
              { required: true, message: t("login.password") + " zorunludur!" }
            ]}
            extra={
              <Link
                to="/forgot-password"
                className="flex justify-end text-blue-500"
              >
                {t("login.forgotPassword")}
              </Link>
            }
          >
            <Input.Password
              placeholder={t("login.password")}
              value={password}
              onChange={(e) => setPassword(e.target.value.trim())}
            />
          </Form.Item>

          <Form.Item className="flex text-start justify-start">
            <Checkbox
              checked={checkForm}
              onChange={(e) => setCheckForm(e.target.checked)}
            >
              <Button
                type="link"
                onClick={() => setIsModalOpen(true)}
                className="text-blue-500"
              >
                {t("login.tncCheckbox")}
              </Button>
            </Checkbox>
          </Form.Item>

          <Form.Item>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              className="w-full"
              disabled={!nationalIdentifier || !password || !checkForm}
            >
              {t("login.loginButton")}
            </Button>
          </Form.Item>
        </Form>

        <div className="flex justify-end items-end">
          <p className="text-sm text-gray-600">
            <Trans
              i18nKey="login.contactUs"
              components={{
                1: (
                  <a
                    href="https://www.onedose.io/iletisim/"
                    className="text-blue-500"
                    rel="noopener noreferrer"
                    target="_blank"
                  />
                )
              }}
            />
          </p>
        </div>
      </Card>

      <Modal
        title={t("login.tncModalTitle")}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button
            type="text"
            key="cancel"
            onClick={() => setIsModalOpen(false)}
          >
            {t("login.cancel")}
          </Button>,
          <Button
            key="accept"
            type="text"
            onClick={() => {
              setCheckForm(true);
              setIsModalOpen(false);
            }}
          >
            {t("login.accept")}
          </Button>
        ]}
      >
        <iframe
          src="https://www.onedose.io/kisisel-verilerin-aktarilmasina"
          title="Şartlar ve Koşullar"
          width="100%"
          height="400px"
          style={{ border: "none" }}
        ></iframe>
      </Modal>

      <Modal
        title={t("login.twoFactorTitle")}
        open={isTfaModalOpen}
        onCancel={() => setIsTfaModalOpen(false)}
        footer={null}
        centered
      >
        <Input
          value={tfaCode}
          onChange={(e) => setTfaCode(e.target.value)}
          placeholder={t("login.twoFactorPlaceholder")}
          className="mt-4"
        />
        <Button
          size="large"
          type="primary"
          htmlType="submit"
          className="w-full mt-4"
          onClick={handleTfaSubmit}
        >
          {t("login.twoFactorConfirm")}
        </Button>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return state;
};
export default connect(mapStateToProps)(Login);
